// extracted by mini-css-extract-plugin
export default {"ctaContainer":"VehicleCategory_ctaContainer__9aTEY","link":"VehicleCategory_link__XLcZo","typeHeading":"VehicleCategory_typeHeading__ySR7q"};